<template>
  <button type="button" class="btn btn-primary" @click="show = true">Operator Quotation</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Operator Quotation</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label>Journeys</label>
            <div v-for="(journey, journeyIndex) in journeysData" :key="journeyIndex">
              <div class="fw-bold">{{ findAirport(form.journeys[journeyIndex].departure.from).iata }} | {{ findAirport(form.journeys[journeyIndex].departure.to).iata }} - {{ form.journeys[journeyIndex].departure.departure_date }} {{ form.journeys[journeyIndex].trip == 'round' ? 'Roundtrip' : 'One way' }} {{ findType(form.journeys[journeyIndex].type).name }}</div>
              <div class="form-check" v-for="(operator, index) in journey" :key="index" @change="addOperatorJourney($event, journeyIndex, operator)">
                <input class="form-check-input" type="checkbox" :value="operator" :id="`j-${journeyIndex}-${operator.id}`">
                <label class="form-check-label" :for="`j-${journeyIndex}-${operator.id}`">
                  {{ operator.name }}
                </label>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label>Inserts</label>
            <div class="form-check" v-for="Insert in getInserts()" :key="Insert.id">
              <input class="form-check-input" type="checkbox" :value="Insert.id" :id="`i-${Insert.id}`" v-model="mail.inserts">
              <label class="form-check-label" :for="`i-${Insert.id}`">
                {{ Insert.name }}
              </label>
            </div>
          </div>

          <div class="mb-3">
            <label for="">Mail Subject:</label>
            <input type="text" class="form-control" v-model="mail.subject">
          </div>

          <div class="mb-3">
            <label for="">Mail body:</label>
            <editor
              api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
              v-model="mail.body"
              :init="{
                height: 300,
                menubar: false,
                plugins: ['lists', 'link', 'code'],
                toolbar:
                  'undo redo | styles | forecolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link code'
              }"
            />
          </div>
          <div class="mb-3">
            <label for="">Available tags:</label>
            <div class="tags">
              <span class="tag" v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="sendMail()">Send Mail</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
import axios from 'axios'
import throttle from 'lodash/throttle'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'Quotation',
  components: {
    Editor
  },
  props: ['bookings', 'form', 'mail_inserts'],
  data() {
    return {
      show: false,
      journeysData: [],
      mail: this.$inertia.form({
        subject: 'Quotation request for ',
        body: null,
        inserts: [],
        template: null,
        journeys: this.form.journeys,
      }),
      tags: [
        '{{ operator_name }}',
        '{{ operator_contact_name }}',
        '{{ booking_number }}',
        '{{ ticket_count }}',
        '{{ passengers }}',
        '{{ itinerary }}',
      ]
    }
  },
  created() {
    this.getJourneys()
  },
  methods: {
    async getOperators(typeId) {
      if (typeId) {
        const getOperator = await axios.get(`/settings/get/operators`, {
          params: { 'types': typeId }
        })
        return getOperator.data;
      }
    },
    async getJourneys() {
      let output = [];
      this.form.journeys.forEach(journey => {
        axios.get(`/settings/get/operators`, {
          params: { 'types': journey.type }
        }).then(operators => {
          return output.push(operators.data)} );
      })

      this.journeysData = output;
    },
    addOperatorJourney($event, journeyIndex, operator) {
      this.$nextTick(() => {
        if (! this.mail.journeys[journeyIndex].operator_quotation) {
          this.mail.journeys[journeyIndex].operator_quotation = []
        }
        if ($event.target.checked) {
            this.mail.journeys[journeyIndex].operator_quotation.push(operator)
        } else {
          let i = this.mail.journeys[journeyIndex].operator_quotation.map(item => item.id).indexOf(operator.id)
          this.mail.journeys[journeyIndex].operator_quotation.splice(i, 1)
        }
      })
    },
    getInserts() {
      let inserts = this.mail_inserts.filter(obj => {
        return obj.group === 'operator'
      })
      return inserts
    },
    findAirport(airportId) {
      return this.$parent.airports.filter(function(item){
          if(item.id == airportId) return item;
      })[0]
    },
    findOperator(operatorId) {
      return this.$parent.operators.filter(function(item){
          if(item.id == operatorId) return item;
      })[0]
    },
    findType(typeId) {
      return this.$parent.types.filter(function(item){
          if(item.id == typeId) return item;
      })[0]
    },
    sendMail() {
        this.mail.put(`/bookings/${this.bookings.id}/mail-quotation`)
        this.show = false
    },
  }
}
</script>

<style>

</style>
